export default __webpack_public_path__ + "4264abc40db8e7799f72c3a2eee84468.png";